module.exports = __webpack_public_path__ + "img/blue_bg2.7d27ceeb.png";